<template>
  <div class="statistical-detail">
    <el-input
      placeholder="请输入姓名/内容"
      class="select-input"
      prefix-icon="el-icon-search"
      @input="selectChangeM"
      v-model="input">
    </el-input>

    <div class="personal-info">
      <div class="info-item" v-for="item in personalInfoList" :key="item.empNo" @click="infoItemM(item)">
        <div class="head-portrait">
          <img v-if="item.imgUrl" :src="item.imgUrl" alt="">
        </div>
        <div class="info">
          <div class="info-top">{{item.empName}}</div>
          <div class="info-bottom">{{item.orgName}}</div>
        </div>
        <div class="score">{{item.grade}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
export default {
  data() {
    return {
      input: '',
      personalInfoList: [],
      dataPickerYearVal: '',
    }
  },
  mounted() {
    this.dataPickerYearVal = this.$route.query.dataPickerYearVal
    this.item = JSON.parse(this.$route.query.item)
    this.salaryInfo = JSON.parse(this.$route.query.salaryInfo)
    
    this.initData()
  },
  methods: {
    //获取个人信息列表
    initData() {
      api.selectListByLevel(
        {
          empNo: this.salaryInfo.empNo,
          // empNo: '10003089',
          searchYear: this.dataPickerYearVal,
          code: this.item.detail.substring(0,1),
          empName: this.input,
          dept: this.input,
        }
      ).then((res) => {
        // 判断 data 是否为数组 & 长度大于0
        if(res.data instanceof Array && res.data.length > 0) {
          this.personalInfoList = res.data
        }
      })
    },
    //跳转
    infoItemM(item) {
      this.$router.push({
        path: '/mobile/diligence/detail',
        query: {
          time: this.dataPickerYearVal,
          empNo: item.empNo,
          date: 10
        }
      })
    },
    selectChangeM() {
      this.initData()
    }
  }
}
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .statistical-detail {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .statistical-detail {
    width: 276px * $zoom;
  }
}
.statistical-detail {
  // width: 100%;
  min-height: 100vh;
  background: #f4f5f8;
  padding: 15px * $zoom 10px * $zoom;
  .select-input {
    ::v-deep {
      .el-input__inner {
        display: flex;
        align-items: center;
        height: 20px * $zoom;
        border: none;
        border-radius: 6px * $zoom;
      }
    }
  }
  .personal-info {
    margin-top: 20px * $zoom;
    border-radius: 10px * $zoom;
    background: #fff;
    .info-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 60px * $zoom;
      margin: 0 10px * $zoom;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      &:last-child {
        border: none;
      }
      .head-portrait {
        overflow: hidden;
        height: 40px * $zoom;
        width: 40px * $zoom;
        margin-right: 10px * $zoom;
        background: #eee;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        width: 70%;
        .info-top {
          font-size: 12px * $zoom;
        }
        .info-bottom{
          margin-top: 5px * $zoom;
          font-size: 8px * $zoom;
        }
      }
    }
  }
}
</style>